export default function AboutSection() {
  return (
    <section id="about" className="py-16 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1280px] mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 text-center lg:text-left">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-4">
              关于哔咔动漫
            </h2>
            <div className="text-sm md:text-base text-foreground-600 leading-relaxed space-y-4 max-w-xl mx-auto lg:mx-0">
              <p>
                哔咔动漫成立于2020年，是国内领先的免费漫画在线阅读平台。我们汇聚了来自日本、韩国以及国内优秀创作者的数万部漫画作品，
                致力于为广大漫友提供最便捷、最舒适的阅读环境。
              </p>
              <p>
                平台采用先进的下拉式阅读技术，完美适配桌面端和移动端。无需跳转翻页，一滑到底，让追更变成一种享受。
                我们坚持<strong className="text-foreground-800">全站免费</strong>的原则，所有作品均可无限制阅读，不设置任何付费壁垒。
              </p>
              <p>
                无论你是热衷热血战斗的少年漫迷，还是偏爱甜宠恋爱的少女漫读者，抑或是追求悬疑烧脑的推理爱好者，
                在哔咔动漫你都能找到最适合自己的漫画世界。
              </p>
            </div>
          </div>

          <div className="flex-shrink-0 w-full max-w-[400px] aspect-[4/3] rounded-2xl overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=Cozy%20reading%20nook%20with%20tablet%20displaying%20colorful%20manga%20pages%2C%20surrounded%20by%20manga%20volumes%20stacked%20on%20wooden%20shelves%2C%20warm%20ambient%20lighting%20from%20desk%20lamp%2C%20Japanese%20decor%20elements%20like%20paper%20lanterns%20and%20bamboo%2C%20soft%20coral%20and%20cream%20color%20palette%2C%20inviting%20atmosphere%20with%20tea%20cup%20on%20side%2C%20editorial%20lifestyle%20photography%20style&width=800&height=600&seq=about-manga-platform&orientation=landscape"
              alt="关于哔咔动漫 - 免费漫画在线阅读平台品牌介绍"
              className="w-full h-full object-cover object-top"
            />
          </div>
        </div>
      </div>
    </section>
  );
}